import React from 'react'
import Cardboard from './Partials/Cardboard'
import AllDashboardChart from './Partials/AllDashboardChart'


export const Home = () => {
  return (
    <>
    <Cardboard/>
    <AllDashboardChart/>
    </>
  )
}

